import React from 'react';
import clsx from 'clsx';

import { BaseComponentProps } from '@utils/types/baseComponents';
import { MinMaxType } from '@utils/types/searchListingsContext';
import Select from '@components/_shared/select';
import { Option } from '@components/_shared/select';

import styles from './styles.module.scss';

type Props = {
  value: MinMaxType;
  onChange: (value: MinMaxType) => void;
  options: Option[];
  selectorStyle?: string;
  emptyValue?: string;
} & BaseComponentProps;

MinMaxSelectors.defaultProps = {
  value: { min: '', max: '' },
};

export function MinMaxSelectors(props: Props) {
  const {
    containerStyle,
    value,
    onChange,
    options,
    selectorStyle,
    emptyValue,
  } = props;

  return (
    <div className={clsx([styles.minMaxSelectors, containerStyle])}>
      <Select
        value={value?.min}
        options={options}
        onSelect={(val) => onChange({ ...value, min: val as string })}
        placeholder={emptyValue || 'No min'}
        containerStyle={clsx([styles.minMaxSelectors__selector, selectorStyle])}
        customEmptyValue={
          emptyValue ? { label: emptyValue, value: '' } : undefined
        }
        withRoundCorners
      />

      <div className={styles.minMaxSelectors__dash} />

      <Select
        value={value?.max}
        options={options}
        onSelect={(val) => onChange({ ...value, max: val as string })}
        placeholder={emptyValue || 'No max'}
        containerStyle={clsx([styles.minMaxSelectors__selector, selectorStyle])}
        customEmptyValue={
          emptyValue ? { label: emptyValue, value: '' } : undefined
        }
        withRoundCorners
      />
    </div>
  );
}
